import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment.development';
import { TrigerToastService } from './triger-toast.service';
import { Router } from '@angular/router';
import { POSRoleName } from '../interfaces/POSroleName.interface';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  sharedData = new BehaviorSubject({});

  public currancySign: string = 'RS';

  public POSRoleName: POSRoleName = {
    super_admin: '',
    restaurant_owner: '',
    branch_owner: '',
    pos_manager: 'POS Manager',
    pos_order_taker: 'POS Order Taker',
    pos_kitchen_manager: 'POS Kitchen Manager',
    pos_kitchen: 'POS Kitchen',
    pos_dispatcher: 'POS Dispatcher',
    pos_tab_order_taker: '',
    pos_pra_order_taker: '',
  };

  private POSRoleIds = {
    super_admin: 0,
    restaurant_owner: 0,
    branch_owner: 0,
    pos_manager: 7,
    pos_order_taker: 8,
    pos_kitchen_manager: 9,
    pos_kitchen: 10,
    pos_dispatcher: 14,
    pos_tab_order_taker: '',
    pos_pra_order_taker: '',
  };

  constructor(
    private httpClient: HttpClient,
    private toastS: TrigerToastService,
    private router: Router
  ) {
    this.loadCurrencyFromStorage();
  }

  public loadCurrencyFromStorage(): void {
    this.getData().subscribe((data: any) => {
      if (data) {
        this.currancySign = data.user?.currency;
      }
    });
  }
  private handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.status === 400) {
      errorMessage = 'Bad Request (400)';
    } else if (error.status === 401) {
      errorMessage = 'Unauthorized (401)';
      this.router.navigate(['/login']);
    } else {
      errorMessage = `Error: ${error.message}`;
    }
    // this.toastS.showToast({
    //   type: 'error',
    //   shortMessage: 'Error!',
    //   Message: error?.error?.Message,
    // });
    return of({
      success: false,
      Success: false,
      error: errorMessage,
      Message: error?.error?.Message || 'Something went wrong!',
      status: error.status,
    });
  }

  private getToken() {
    let localStorageData = JSON.parse(
      sessionStorage.getItem(`sharedData@${environment.appName}`) || '{}'
    );
    if (localStorageData && localStorageData.user) {
      return localStorageData.user.token ?? null;
    }
    return null;
  }

  /** to get data this.sharedService.getData().subscribe((data: any) => {}) **/
  public getData() {
    let storedData = sessionStorage.getItem(
      `sharedData@${environment.appName}`
    );
    this.sharedData.next(JSON.parse(storedData || '{}'));
    return this.sharedData.asObservable();
  }

  /** to insert data this.sharedService.insertData({ key: 'name', val: response.data }) **/
  public insertData(data: any) {
    this.sharedData.next({
      ...this.sharedData.getValue(),
      [data.key]: data.val,
    });
    sessionStorage.setItem(
      `sharedData@${environment.appName}`,
      JSON.stringify(this.sharedData.value)
    );
  }

  resetLocalStorageData() {
    this.sharedData.next({});
    sessionStorage.setItem(
      `sharedData@${environment.appName}`,
      JSON.stringify({})
    );
  }

  /** Get Request with auth Token **/
  public sendGetRequest(target: string): Observable<any> {
    let token = this.getToken();
    const headers_object = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const httpOptions = {
      headers: headers_object,
    };
    return this.httpClient
      .get<any>(environment.apiUrl + target, httpOptions)
      .pipe(
        catchError((error) => this.handleError(error)) // Modified to include target information
      );
  }


  /** Get Request with auth token with old API **/
  public sendGetRequestOldAPI(target: string): Observable<any> {
    let token = this.getToken();
    const headers_object = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const httpOptions = {
      headers: headers_object,
    };
    return this.httpClient
      .get<any>(environment.oldApiUrl + target, httpOptions)
      .pipe(
        catchError((error) => this.handleError(error)) // Modified to include target information
      );
  }

  /** Post Request with token auth **/
  public sendPostRequest(target: string, data: any): Observable<any> {
    let token = this.getToken();
    const headers_object = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const httpOptions = {
      headers: headers_object,
    };
    return this.httpClient
      .post<any>(environment.apiUrl + target, data, httpOptions)
      .pipe(
        catchError((error) => this.handleError(error)) // Modified to include target information
      );
  }


    /** Post Request for DC with token auth **/


  public sendPostRequestForDC(target: string, data: any): Observable<any> {
    let token = this.getToken();
    const headers_object = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const httpOptions = {
      headers: headers_object,
    };
    return this.httpClient
      .post<any>(environment.oldApiUrl + target, data, httpOptions)
      .pipe(
        catchError((error) => this.handleError(error)) // Modified to include target information
      );
  }


  /** Post Request For Reports with token auth **/

  public sendPostRequestForReports(target: string, data: any): Observable<any> {
    let token = this.getToken();
    const headers_object = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const httpOptions = {
      headers: headers_object,
    };
    return this.httpClient
      .post<any>(environment.oldApiUrl + target, data, httpOptions)
      .pipe(
        catchError((error) => this.handleError(error)) // Modified to include target information
      );
  }

  /** Put Request **/
  public sendPutRequest(target: string, data: any): Observable<any> {
    return this.httpClient.put<any[]>(environment.apiUrl + target, data).pipe(
      catchError((error) => this.handleError(error)) // Modified to include target information
    );
  }

  /** Patch Request **/
  public sendPatchRequest(target: string, data: any): Observable<any> {
    return this.httpClient
      .patch<any[]>(environment.apiUrl + target, data)
      .pipe(catchError(this.handleError.bind(this)));
  }

  /** Delete Request **/
  public sendDeleteRequest(target: string): Observable<any> {
    return this.httpClient
      .delete<any[]>(environment.apiUrl + target)
      .pipe(catchError(this.handleError.bind(this)));
  }

  /** Delete Request with token auth **/
  public sendDeleteRequest2(target: string, token: any): Observable<any> {
    const headers_object = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const httpOptions = {
      headers: headers_object,
    };
    return this.httpClient
      .delete<any[]>(environment.apiUrl + target, httpOptions)
      .pipe(catchError(this.handleError.bind(this)));
  }

  /** Download File Request with token auth **/
  public downloadFileWithToken(target: string, token: any): Observable<Blob> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.httpClient.get(environment.apiUrl + target, {
      responseType: 'blob',
      headers,
    });
  }

  /** Getting Layout Setting Object **/
  getLayoutSetting() {
    let storedData = sessionStorage.getItem(`layout`);
    return JSON.parse(storedData || '{}');
  }
}
